import React, { ReactElement } from "react";
import VrHistoryList from "../../components/Finance/VRHistory";
import Layout from "../../components/layout";

const VRHistoryPage = (): ReactElement => {
  return (
    <Layout>
      <VrHistoryList />
    </Layout>
  );
};

export default VRHistoryPage;
